<div class="modal" [ngStyle]="{'display': visible}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-backdrop fade in" style="height: 2607px;"></div>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 550px;margin-left: 5%;    border-radius: 7px;">
      <div class="modal-header hide" style="line-height: 0.5;border-bottom: 1px solid #17a2b8;background: #17a2b8;border-top-right-radius: 7px;border-top-left-radius: 7px;">
        <div class="modal-title" style="color: #030303;font-size: 20px;font-variant-caps: all-small-caps;font-weight: 500">
          <span style="margin-left: 10px;text-transform: none">{{title}}</span>
        </div>
      </div>
      <div class="modal-body" [innerHTML]="confirmationMessage"></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary active" data-dismiss="modal" (click)="popupOkAction()">{{ok_button_text}}</button>
        <button type="button" class="btn btn-primary active" data-dismiss="modal" (click)="popupCancelAction()">{{cancel_button_text}}</button>
      </div>
    </div>
  </div>
</div>
